import React from 'react'
import {Button, Icon} from 'common/components'
import {useTranslation} from 'i18n'
import {GiftshopPackageActivesResponse} from 'types'
import {getCurrencyValue} from 'utils'

interface GiftShopPackageCartButtonProps {
  isCart: boolean
  packageData: GiftshopPackageActivesResponse
  onPressAddToCart: () => void
  onPressRemoveFromCart: () => void
}

export function GiftShopPackageCartButton({
  isCart,
  packageData,
  onPressAddToCart,
  onPressRemoveFromCart,
}: GiftShopPackageCartButtonProps) {
  const {translate} = useTranslation()

  return isCart ? (
    <Button
      backgroundColor="white_1"
      color="primary_5"
      leftIcon={<Icon type="check" color="primary_5" />}
      label={translate('giftShop:packageDetailAddedToCart')}
      onClick={() => {
        onPressRemoveFromCart()
      }}
    />
  ) : (
    <Button
      leftIcon={<Icon type="collection" color="white_1" />}
      label={translate('giftShop:packageDetailButton', {
        price: getCurrencyValue(packageData.price),
      })}
      onClick={() => {
        onPressAddToCart()
      }}
    />
  )
}
